export default __webpack_public_path__ + "static/media/ag.749fabad.svg";